import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { ChevronDown, Building2, Check } from "lucide-react";
import { cn } from "@/lib/utils";
import { useBranchFilterStore } from "@/lib/stores/branch-filter";

const branches = [
  { id: null, name: "全部館" },
  { id: "br_001", name: "旗艦館" },
  { id: "br_002", name: "二館" },
] as const;

export function BranchFilter() {
  const branchId = useBranchFilterStore((s) => s.branchId);
  const setBranch = useBranchFilterStore((s) => s.setBranch);
  const current = branches.find((b) => b.id === branchId) ?? branches[0];

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger
        className={cn(
          "inline-flex h-8 items-center gap-2 rounded-md border border-border bg-surface px-3",
          "text-sm font-medium text-ink-700",
          "transition-colors hover:border-ink-400 hover:bg-ink-50",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2",
        )}
        aria-label="篩選館別"
      >
        <Building2 className="h-3.5 w-3.5 text-ink-400" aria-hidden />
        {current.name}
        <ChevronDown className="h-3.5 w-3.5 text-ink-400" aria-hidden />
      </DropdownMenu.Trigger>

      <DropdownMenu.Portal>
        <DropdownMenu.Content
          className="z-50 min-w-[160px] rounded-md border border-border bg-surface py-1 shadow-md"
          sideOffset={6}
          align="start"
        >
          {branches.map((branch) => {
            const active = branchId === branch.id;
            return (
              <DropdownMenu.Item
                key={branch.id ?? "all"}
                onSelect={() => setBranch(branch.id)}
                className={cn(
                  "flex cursor-pointer items-center gap-2 px-3 py-2 text-sm font-medium outline-none",
                  active ? "text-primary-700" : "text-ink-700 hover:bg-ink-50",
                )}
              >
                <Check
                  className={cn("h-3.5 w-3.5 shrink-0", active ? "text-primary-500" : "opacity-0")}
                  aria-hidden
                />
                {branch.name}
              </DropdownMenu.Item>
            );
          })}
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
